import type {FieldValues} from 'react-hook-form';
import {z} from 'zod';

import i18n from '@/i18n';

import type {AnyExportDefinition} from '../types/exportTypes';
import type {ExportFormat} from './exportFormats';
import {EXPORT_FORMATS} from './exportFormats';
import {noOptions} from './exportOptions';

export const createExportFormSchema = (definition?: AnyExportDefinition) => {
  const optionsSchema: z.ZodType<FieldValues, FieldValues> =
    definition?.optionsSchema ?? noOptions.optionsSchema;

  return z.object({
    list: z.string().min(1, i18n.t('Data is required')),
    format: z.enum(EXPORT_FORMATS),
    options: optionsSchema,
  });
};

export type ExportFormValues<TOptions extends FieldValues = FieldValues> = {
  list: string;
  format: ExportFormat;
  options: TOptions;
};

export const exportFormDefaultValues = (
  searchParams: URLSearchParams,
  definition?: AnyExportDefinition
): ExportFormValues => ({
  list: definition?.id ?? '',
  format: 'csv',
  options: definition?.getDefaultOptions(searchParams) ?? {},
});
